import Store from '@/globals/store.js'
import DoctorIndex from '@/views/doctor/index'
import DoctorLogin from '@/views/doctor/Login'
// import DoctorDashboard from '@/views/doctor/Dashboard'
import DoctorPlans from '@/views/doctor/Plans'
import DoctorPlansOverview from '@/components/layout/plans/overview'
import DoctorPlansReceipts from '@/components/layout/plans/receipts'
import DoctorPlansDetails from '@/components/layout/plans/details'
import DoctorPlansCheckout from '@/components/layout/plans/checkout'

import DoctorAgenda from '@/views/doctor/Agenda'
import DoctorUser from '@/views/doctor/User'
import DoctorUserInfo from '@/components/layout/user/userForm'
import DoctorUserOffices from '@/components/layout/user/offices'
import DoctorUserBankDetails from '@/components/layout/user/bankDetails'
import DoctorUserPresentation from '@/components/layout/user/presentation'
import DoctorUserSignature from '@/components/layout/user/signature'
import DoctorUserCertificates from '@/components/layout/user/certificates'
import DoctorUserCancelAccount from '@/components/layout/user/cancelAccount'
import DoctorModels from '@/views/doctor/Models'
import DoctorModelsPrescription from '@/components/layout/models/prescription'
import DoctorModelsSicknote from '@/components/layout/models/attestation'
import DoctorModelsFiles from '@/components/layout/models/files'
import DoctorModelsAnamnesisList from '@/components/layout/models/anamnesisList'
import DoctorModelsAnamnesisDetails from '@/components/layout/models/anamnesisDetails'
import DoctorPrices from '@/views/doctor/Prices'
import DoctorAppointments from '@/views/doctor/Appointments'
import DoctorAppointmentsList from '@/components/layout/appointments/list'
import DoctorAppointmentsGuide from '@/components/layout/appointments/guide'
import DoctorPatients from '@/views/doctor/Patients'
import DoctorPatientsList from '@/components/layout/patient/list'
import DoctorPatientsDetails from '@/components/layout/appointments/appointment.vue'
import DoctorPatientsImport from '@/components/layout/patient/import/'
import DoctorPatientsImportPreview from '@/components/layout/patient/import/preview'
import DoctorPatientsImportIdentify from '@/components/layout/patient/import/identifyColumns'
import DoctorPatientsImportExecute from '@/components/layout/patient/import/actionPreview'
import DoctorPatientsImportFinished from '@/components/layout/patient/import/finished'
import DoctorFinances from '@/views/doctor/Finances'
import DoctorFinancesOverview from '@/components/layout/finances/overview'
import DoctorFinancesDetailed from '@/components/layout/finances/detailed'
import DoctorUsersOffice from '@/views/doctor/UsersOffice'
import DoctorUsersOfficeList from '@/components/layout/users-office/list'
import DoctorUsersOfficeForm from '@/components/layout/users-office/form'
import DoctorReports from '@/views/doctor/Reports'
import DoctorHistory from '@/views/doctor/History'
import DoctorHistoryList from '@/components/layout/history/list'
import tableContainer from '@/components/tables/tableContainer.vue'
// import DoctorStatement from '@/views/doctor/Statement'
// import blank from '@/components/layout/blank'
import DoctorAppIntegration from '@/views/doctor/AppIntegration'
import DoctorAppIntegrationPresentation from '@/components/layout/appIntegration/presentation'
import DoctorAppIntegrationEducation from '@/components/layout/appIntegration/education'
import DoctorAppIntegrationOffices from '@/components/layout/appIntegration/offices'
import DoctorAppIntegrationPrices from '@/components/layout/appIntegration/prices'
import DoctorAppIntegrationFinance from '@/components/layout/appIntegration/finance'
import DoctorAppIntegrationHealthPlace from '@/components/layout/appIntegration/healthPlace'
import DoctorAppIntegrationReview from '@/components/layout/appIntegration/review'

const children = [
  {
    path: 'login',
    name: 'DoctorLogin',
    component: DoctorLogin,
    meta: {
      sidebar: false
    }
  },
  {
    path: 'plans',
    name: 'DoctorPlans',
    component: DoctorPlans,
    meta: {
      sidebar: false,
      title: 'Planos'
    },
    redirect: { name: 'DoctorPlansOverview' },
    children: [
      {
        path: '',
        name: 'DoctorPlansOverview',
        component: DoctorPlansOverview
      },
      {
        path: 'receipts',
        name: 'DoctorPlansReceipts',
        component: DoctorPlansReceipts
      },
      {
        path: 'details',
        name: 'DoctorPlansDetails',
        component: DoctorPlansDetails
      },
      {
        path: 'checkout',
        name: 'DoctorPlansCheckout',
        component: DoctorPlansCheckout
      }
    ]
  },
  {
    path: '',
    name: 'DoctorAgenda',
    component: DoctorAgenda,
    meta: {
      sidebar: true,
      title: 'Agenda',
      icon: 'menuAgenda'
    },
    children: [
      {
        path: ':doctorOffice/new',
        name: 'DoctorAgendaNew',
        component: DoctorAgenda,
        meta: {
          new: true
        }
      }
    ]
  },
  {
    path: 'appointments',
    component: DoctorAppointments,
    name: 'DoctorAppointments',
    meta: {
      sidebar: true,
      title: 'Agendamentos',
      icon: 'menuAgendamentos'
    },
    redirect: { name: 'DoctorAppointmentsList' },
    children: [
      {
        path: 'list',
        name: 'DoctorAppointmentsList',
        component: DoctorAppointmentsList
      },
      {
        path: 'guide/:agendaId',
        name: 'DoctorAppointmentsGuide',
        component: DoctorAppointmentsGuide
      },
      {
        path: ':patientType/:id/:agendaId',
        name: 'DoctorAppointmentsDetails',
        component: DoctorPatientsDetails
      }
    ]
  },
  {
    path: 'patients',
    name: 'DoctorPatients',
    component: DoctorPatients,
    meta: {
      sidebar: true,
      title: 'Pacientes',
      icon: 'menuPacientes'
    },
    redirect: '/doctor/patients/list/specialPatient',
    children: [
      {
        path: 'list/:type?',
        component: DoctorPatientsList,
        name: 'DoctorPatientsList'
      },
      {
        path: 'import',
        name: 'DoctorPatientsImport',
        redirect: { name: 'DoctorPatientsImportPreview' },
        component: DoctorPatientsImport,
        children: [
          {
            path: '',
            name: 'DoctorPatientsImportPreview',
            component: DoctorPatientsImportPreview
          },
          {
            path: ':type/identify',
            name: 'DoctorPatientsImportIdentify',
            component: DoctorPatientsImportIdentify
          },
          {
            path: ':type/execute',
            name: 'DoctorPatientsImportExecute',
            component: DoctorPatientsImportExecute
          },
          {
            path: ':type/finished',
            name: 'DoctorPatientsImportFinished',
            component: DoctorPatientsImportFinished
          }
        ]
      },
      {
        path: 'details/:patientType/:id',
        name: 'DoctorPatientsDetails',
        component: DoctorPatientsDetails
      }
    ]
  },
  {
    path: 'finances',
    name: 'DoctorFinances',
    component: DoctorFinances,
    redirect: { name: 'DoctorFinancesOverview' },
    meta: {
      sidebar: true,
      title: 'Extrato',
      icon: 'menuExtrato'
    },
    children: [
      {
        path: 'overview',
        name: 'DoctorFinancesOverview',
        component: DoctorFinancesOverview
      },
      {
        path: 'list',
        name: 'DoctorFinancesDetailed',
        component: DoctorFinancesDetailed
      }
    ]
  },
  {
    path: 'services',
    name: 'DoctorServices',
    component: DoctorPrices,
    meta: {
      sidebar: true,
      title: 'Serviços',
      icon: 'menuServicos'
    }
  },
  {
    path: 'models',
    component: DoctorModels,
    name: 'DoctorModels',
    meta: {
      profile: true,
      sidebar: false,
      title: 'Configurar Modelos',
      icon: 'menuModelos'
    },
    redirect: { name: 'DoctorModelsAnamnesis' },
    children: [
      {
        path: 'documents',
        name: 'DoctorModelsFiles',
        component: DoctorModelsFiles
      },
      {
        path: 'prescriptions',
        name: 'DoctorModelsPrescriptions',
        component: DoctorModelsPrescription
      },
      {
        path: 'sicknotes',
        name: 'DoctorModelsSicknotes',
        component: DoctorModelsSicknote
      },
      {
        path: 'anamnesis',
        name: 'DoctorModelsAnamnesis',
        component: { render: (h) => h('router-view') },
        redirect: { name: 'DoctorModelsAnamnesisList' },
        children: [
          {
            path: 'list',
            name: 'DoctorModelsAnamnesisList',
            component: DoctorModelsAnamnesisList
          },
          {
            path: 'details/:id?',
            name: 'DoctorModelsAnamnesisDetails',
            component: DoctorModelsAnamnesisDetails
          }
        ]
      }
    ]
  },
  // {
  //   path: 'users',
  //   component: DoctorUsersOffice,
  //   name: 'DoctorUsersOffice',
  //   meta: {
  //     profile: true,
  //     title: 'Usuários Cadastrados',
  //     icon: 'usuarios'
  //   },
  //   redirect: { name: 'DoctorUsersOfficeList' },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'DoctorUsersOfficeList',
  //       component: DoctorUsersOfficeList
  //     },
  //     {
  //       path: 'new',
  //       name: 'DoctorUsersOfficeNew',
  //       component: DoctorUsersOfficeForm
  //     },
  //     {
  //       path: 'edit/:id',
  //       name: 'DoctorUsersOfficeEdit',
  //       component: DoctorUsersOfficeForm
  //     }
  //   ]
  // },
  {
    path: 'reports/:type?',
    name: 'DoctorReports',
    component: DoctorReports,
    meta: {
      sidebar: true,
      title: 'Relatórios',
      icon: 'menuRelatorios'
    }
  },
  {
    path: 'history',
    name: 'DoctorHistory',
    component: DoctorHistory,
    meta: {
      sidebar: true,
      title: 'Histórico',
      icon: 'menuHistorico'
    },
    redirect: { name: 'DoctorHistoryList' },
    children: [
      {
        path: '',
        name: 'DoctorHistoryList',
        component: DoctorHistoryList
      }
    ]
  },
  {
    path: 'user',
    name: 'DoctorUser',
    component: DoctorUser,
    meta: {
      title: 'Minha conta'
    },
    redirect: { name: 'DoctorUserInfo' },
    children: [
      {
        path: 'info',
        name: 'DoctorUserInfo',
        component: DoctorUserInfo
      },
      {
        path: 'offices',
        name: 'DoctorUserOffices',
        component: DoctorUserOffices
      },
      {
        path: 'bankdetails',
        name: 'DoctorUserBankDetails',
        component: DoctorUserBankDetails
      },
      {
        path: 'presentation',
        name: 'DoctorUserPresentation',
        component: DoctorUserPresentation
      },
      {
        path: 'signature',
        name: 'DoctorUserSignature',
        component: DoctorUserSignature
      },
      {
        path: 'certificate',
        name: 'DoctorUserCertificates',
        component: DoctorUserCertificates
      },
      {
        path: 'cancel_account',
        name: 'DoctorUserCancelAccount',
        component: DoctorUserCancelAccount
      },
      {
        path: 'configuration',
        name: 'DoctorUserConfiguration',
        component: () => import('@/components/layout/user/configuration.vue')
      }
    ]
  },
  {
    path: 'app-integration',
    name: 'DoctorAppIntegration',
    component: DoctorAppIntegration,
    meta: {
      title: 'Integração App Dr. Conecta'
    },
    redirect: { name: 'DoctorAppIntegrationPresentation' },
    children: [
      {
        path: 'presentation',
        name: 'DoctorAppIntegrationPresentation',
        component: DoctorAppIntegrationPresentation
      },
      {
        path: 'education',
        name: 'DoctorAppIntegrationEducation',
        component: DoctorAppIntegrationEducation
      },
      {
        path: 'offices',
        name: 'DoctorAppIntegrationOffices',
        component: DoctorAppIntegrationOffices
      },
      {
        path: 'prices',
        name: 'DoctorAppIntegrationPrices',
        component: DoctorAppIntegrationPrices
      },
      {
        path: 'finance',
        name: 'DoctorAppIntegrationFinance',
        component: DoctorAppIntegrationFinance
      },
      {
        path: 'health-place',
        name: 'DoctorAppIntegrationHealthPlace',
        component: DoctorAppIntegrationHealthPlace
      },
      {
        path: 'review',
        name: 'DoctorAppIntegrationReview',
        component: DoctorAppIntegrationReview
      }
    ]
  }
]

for (let child of children) {
  child.beforeEnter = (to, from, next) => {
    if (
      Store.getters.getRoles.indexOf('ROLE_DOCTOR_PRO') === -1 &&
      Store.getters.getRoles.indexOf('ROLE_DOCTOR_FACILITIES') === -1 &&
      !Store.getters.$_checkAuth
    ) {
      Store.dispatch('setModalAlert', {
        title: 'Erro de autenticação',
        body: 'Acesso não permitido',
        size: 'md',
        active: true
      })
      next('')
      return
    }
    if (!Store.getters.$_checkAuth) {
      next('/')
    }
    next()
  }
}

export default {
  path: '/doctor',
  name: 'Doctor',
  component: DoctorIndex,
  redirect: '/agenda',
  children
}
